import React from 'react'
import InputMask from 'react-input-mask'
import * as S from './styles'

interface ITextFieldMaskProps {
  disabled?: boolean
  error?: boolean
  label?: string
  mask: string
  size?: 'small' | 'medium'
  value?: string
  variant?: 'standard' | 'filled' | 'outlined'
  InputProps?: React.ReactNode
  required?: any
  onChangeMask?: (event: any) => void
  onBlurMask?: (event: any) => void
  onKeyDownMask?: (e: any) => void
  onPasteMask?: (e: any) => void
}

const TextFieldMask = ({
  disabled,
  error,
  label,
  mask,
  size,
  value,
  variant,
  InputProps,
  required,
  onChangeMask,
  onBlurMask,
  onKeyDownMask,
  onPasteMask,
}: ITextFieldMaskProps) => {
  return (
    <InputMask
      mask={mask}
      value={value}
      onChange={onChangeMask}
      onBlur={onBlurMask}
      disabled={disabled}
      onPaste={onPasteMask}
    >
      {
        //@ts-ignore
        (inputProps: any) => (
          <S.TextFieldComponent
            error={error}
            label={label}
            required={required}
            InputProps={InputProps}
            variant={variant || 'outlined'}
            disabled={disabled}
            size={size || 'medium'}
            fullWidth
            onKeyDown={(e) => {
              onKeyDownMask && onKeyDownMask(e)
            }}
            {...inputProps}
          />
        )
      }
    </InputMask>
  )
}

export { TextFieldMask }
